<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<div [ngClass]="{ wrap: wrapContent }">
  <div class="flex flex-row" *ngIf="payload.properties.text?.value">
    <div class="flex label-cell">
      <label class="flex jcfe">
        <span>
          <span [innerHTML]="payload.properties.text?.value | tokenToDiv"></span>
          <span class="required" *ngIf="payload.properties.required.value">*</span>
        </span>
      </label>
    </div>
  </div>

  <div class="flex flex-row" *ngIf="payload.properties.content?.value">
    <div class="flex word-wrap">
      <label class="flex jcfe subtitle">
        <span [innerHTML]="payload.properties.content?.value | tokenToDiv"></span>
      </label>
    </div>
  </div>

  <div class="flex flex-row spacing field-columns">
    <div
      class="flex field-cell rel"
      *ngFor="let field of payload.properties.columns; let fieldIndex = index"
      [ngStyle]="{
        width: 100 / payload.properties.columns.length + '%',
      }"
    >
      <div class="flex flex-row" *ngIf="field.text?.value">
        <div class="flex label-cell">
          <label class="flex jcfe">
            <span class="field-label-content">
              <span [innerHTML]="field.text?.value | tokenToDiv"></span>
              <span class="required" *ngIf="!payload.properties.text?.value && payload.properties.required.value">
                *
              </span>
              <fb-scribe-suggestion-indicator [target]="field"></fb-scribe-suggestion-indicator>
              <fb-amendment-field-indicator [fieldKey]="'c' + fieldIndex" />
            </span>
          </label>
        </div>
      </div>
      <ng-select
        [items]="items[fieldIndex]"
        [multiple]="false"
        [closeOnSelect]="true"
        bindLabel="text"
        bindValue="value"
        [placeholder]="isPrinting || isPreview ? '' : field.placeholder?.value"
        [(ngModel)]="field.value.value"
        (ngModelChange)="clearScribeSuggestionMarker(field)"
        [searchable]="false"
        appendTo="body"
      ></ng-select>
    </div>
  </div>

  <div *ngIf="payload.properties.required.value && isSubmitted && !isValid()" class="hint-required">
    This field is required
  </div>
</div>
